import { lazy } from 'react'
export { default as EventHub }
from './EventHub'

export const EventHubDescriptionTab = lazy(() =>
    import ('./tabs/Description'))
export const EventHubDivisionsTab = lazy(() =>
    import ('./tabs/Divisions'))
export const EventHubWorkoutsTab = lazy(() =>
    import ('./tabs/Workouts'))
export const EventHubPlanningTab = lazy(() =>
    import ('./tabs/Planning'))
export const EventHubLeaderboardTab = lazy(() =>
    import ('./tabs/Leaderboard'))
export const EventHubGalleryTab = lazy(() =>
    import ('./tabs/Gallery'))
export const EventHubReviewsTab = lazy(() =>
    import ('./tabs/Reviews'))